// extracted by mini-css-extract-plugin
export default {"companyLogo":"CompanyLogo_companyLogo__SDj77","companyName":"CompanyLogo_companyName__Iwi7l"};